import Service, { inject as service } from '@ember/service';
import { loadScript } from 'sh-www/utils/script-loader';
import config from 'sh-www/config/environment';

const googlePlacesInitializedPromise = new Promise((resolve) => {
  window.initMap = () => {
    resolve();
  };
});

class GooglePlacesService extends Service {
  @service('error-tracker')
  errorTracker;

  #loaded = false;
  #promise = null;

  get loaded() {
    return this.#loaded;
  }

  load() {
    return this.#promise ??= loadScript(`//maps.googleapis.com/maps/api/js?key=${config.GOOGLE_API_KEY}&loading=async&libraries=places&callback=initMap`)
      .then(() => {
        return googlePlacesInitializedPromise;
      })
      .then(() => {
        this.#loaded = true;
      })
      .catch((e) => {
        this.errorTracker.error(e, this, 'unable to load google places api');
        throw e;
      });
  }

  /**
   * Render a map into a specific element id
   *
   * @see https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions
   *
   * @param {String} mapElementId     Element id to render the map into.
   * @param {Number} lat
   * @param {Number} lng
   * @param {Object} otherOptions
   */
  renderMap(mapElementId, lat, lng, otherOptions = {}) {
    if (
      !window.google?.maps?.Map
      || !window.google?.maps?.LatLng
    ) {
      this.errorTracker.error('Error rendering google map', this);
      return;
    }

    const canvasEl = document.getElementById(mapElementId);
    const options = Object.assign({}, {
      center: {
        lat,
        lng,
      },
    }, otherOptions);

    new window.google.maps.Map(canvasEl, options);
  }
}

export default GooglePlacesService;
